var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSelectionGroupAdd = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.625 0c1.252 0 2.286.982 2.37 2.213l.005.162v14.25a2.383 2.383 0 0 1-2.213 2.37l-.162.005H7.375a2.383 2.383 0 0 1-2.37-2.213L5 16.625V2.375C5 1.123 5.982.089 7.213.005L7.375 0h14.25Zm0 1H7.375c-.71 0-1.301.55-1.369 1.243L6 2.375v14.25c0 .71.55 1.301 1.243 1.369l.132.006h14.25c.71 0 1.301-.55 1.369-1.243l.006-.132V2.375c0-.71-.55-1.301-1.243-1.369L21.625 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 5v1h-.625c-.71 0-1.301.55-1.369 1.243L1 7.375v14.25c0 .71.55 1.301 1.243 1.369l.132.006h14.25c.71 0 1.301-.55 1.369-1.243l.006-.132V21h1v.625a2.383 2.383 0 0 1-2.213 2.37l-.162.005H2.375a2.383 2.383 0 0 1-2.37-2.213L0 21.625V7.375c0-1.252.982-2.286 2.213-2.37L2.375 5H3ZM14.5 5c.246 0 .45.155.492.359l.008.078v3.551h3.471a.5.5 0 0 1 .09.992l-.09.008h-3.47v3.56c0 .242-.225.438-.5.438-.246 0-.45-.155-.493-.36L14 13.549v-3.56h-3.5a.5.5 0 0 1-.09-.992l.09-.008H14v-3.55c0-.242.224-.438.5-.438Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSelectionGroupAdd);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/selection-group-add.8ca0a99cd966798db65254b766dd6610.svg";